import { SliderButton } from "@typeform/embed-react";

export default function Feedback() {
  return (
    <SliderButton id="EDKTOIDE" className="">
      Feedback
    </SliderButton>
  );
}
